'use client'
import { InfoTooltip } from '@morpho-org/ui-v6/client'
import { memo, type PropsWithChildren } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface InstantRatesSectionLayoutProps extends PropsWithChildren {
  chartInstantApySlot: React.ReactNode
}

const InstantRatesSectionLayout = ({ chartInstantApySlot }: InstantRatesSectionLayoutProps) => {
  return (
    <div className="gap-sm flex grow flex-col">
      <div className="gap-2xs flex items-center">
        <SubSectionTitle>Instantaneous Rates</SubSectionTitle>
        <InfoTooltip
          tooltipContent={
            <>
              The instantaneous rate reflects the current rate, allowing you to simulate how your
              position changes would affect the rate in real time.
            </>
          }
        />
      </div>
      <div className="gap-sm flex flex-col">{chartInstantApySlot}</div>
    </div>
  )
}

export default memo(InstantRatesSectionLayout)
